import React from 'react'
import tw, { styled } from 'twin.macro'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import ReactPlayer from 'react-player'
import {Helmet} from "react-helmet";
import './styles.css'


const TwoColumn = ({ heading, links, body, reversed, r: { image, tint }, site, ...props }) => {

   const images = image.r?.image && withArtDirection(getImage(image.r.image.file.sharp.lg), [
        {
            media: "(max-width: 768px)",
            image: getImage(image.r.image.file.sharp.alt),
        },
    ])

    links = links.map(link => ({
        ...link,
        path: link.path ? link.path.replace(`/${site}/`, '/') : link.uri.replace('internal:', '')
    }))
    return (
        <Style style={tint ? {'--bg': `var(--nova-${tint?.name})`, '--color': 'white'} : {}} data-tinted={tint?.name} data-reversed={reversed} reversed={reversed} className='promotion two-column' {...props}>
            <div className="two-column__container">
            <article className={['two-column__body', body ? 'has-body' : 'has-no-body'].join(' ')}>
                {heading && <h2>{heading.split('|').map(line => <span key={line}>{line}</span>)}</h2>}
                {body && <div className="two-column__body-prose" dangerouslySetInnerHTML={{ __html: body.html.replaceAll(`/${site}/`, '/') }} />}
                {links.length > 0 && (
                    <ul tw="list-none m-0 p-0 flex gap-2">
                        {links.map(link => (
                            <li key={link.uri}>
                                <a className="two-column__link" href={link.path.replace(`/${site}/`, '/')}>{link.title}</a>
                            </li>
                        ))}
                    </ul>
                )}
            </article>

            { images && (
                <GatsbyImage
                    as="figure"
                    className="two-column__image"
                    image={images}
                    objectFit="contain"
                    alt={heading}
                    />
            )}

            {image.localVideo && (
                <figure className="two-column__image">
                    <video preload="auto" playsInline controls poster={image.localVideo?.poster?.r?.image?.file?.sharp?.resize?.src || null}>
                        <source type="video/mp4" src={image.localVideo.media.file.publicURL} />
                    </video>
                </figure>
            )}

            {image.video && (
                <figure className="two-column__image">
                    <ReactPlayer className="embed" width={'100%'} height={'100%'} url={image.video} title={image.name} />
                </figure>
            )}
            </div>
        </Style>
    )
}
export default TwoColumn



const Style = styled.section`
    article {

        h2 {
            ${tw `font-semibold tracking-tight font-body text-3xl sm:text-4xl mg:text-5xl  mb-6 lg:mb-10 text-inherit`}

            span {
                ${tw `block`}
            }
        }

        &.has-no-body {
            ${tw `self-center`}
        }

        &.has-no-body h2 {
            ${tw `mb-0 mg:text-6xl space-y-4 mg:space-y-8 font-body font-bold`}
        }

        .btn,
        .two-column__link {
            ${tw `
                mt-8
                relative
                z-10
                text-base
                lg:text-lg
                inline-block
                no-underline!
                text-white!
                font-semibold
                px-6
                lg:px-10
                py-3
                leading-none
                whitespace-nowrap
                borderRadius[4em]
                hover:bg-black
                focus-visible:bg-black
                transition-colors
            `}

            ${({ reversed }) => reversed ? tw`bg-primary` : tw`backgroundColor[var(--layout-tint, var(--nova-primary))]`}
        }

        .btn {
            ${tw `mt-0`}
        }

        p:has(.btn) + * {
            ${tw `mt-8!`}
        }

    }

    .two-column__body {
        ${tw `text-lg  leading-relaxed! space-y-[1em]`}

        a {
           ${tw `text-gray-700 underline textUnderlineOffset[.15em] textDecorationThickness[1px] hover:color[var(--layout-tint, var(--nova-dark))]`}
        }


        * + :is(ul, ol) {
            margin-top: 1em;
        }

        ul:not([class]) {
            ${tw`listStyle[disc] marginLeft[1.5em]`}
        }

        ol:not([class]) {
            ${tw`listStyle[auto] marginLeft[1.5em]`}
        }

        ol[type="a"] {
            list-style-type: lower-alpha;
        }
        ol[type="i"] {
            list-style-type: lower-roman;
        }
    }

    .two-column__image {

        .embed {
            ${tw `bg-black aspectRatio[16/9]`}
        }

        iframe {
            ${tw `w-full h-full mb-0 `}
        }

        video {
            ${tw `aspect-video outline-none bg-black object-contain rounded overflow-hidden w-full h-auto`}
        }

        img {
            width: 101% !important; // get around weird 1px border-right
        }
    }

`